import React from 'react';

import PropTypes from 'prop-types';

import { normalizeDocument } from '~/helpers/functions';

import S from '../styles';

function InputDocument({ inputMode, ...inputProps }) {
  const alphanumeric = /[A-Za-z0-9]/;
  const numeric = /\d/;

  const mask = (value) => {
    const newValue = normalizeDocument(value);

    if (inputMode === 'cpf' || /^\d{11}$/.test(newValue)) {
      return [
        numeric,
        numeric,
        numeric,
        '.',
        numeric,
        numeric,
        numeric,
        '.',
        numeric,
        numeric,
        numeric,
        '-',
        numeric,
        numeric,
      ];
    }
    return [
      alphanumeric,
      alphanumeric,
      '.',
      alphanumeric,
      alphanumeric,
      alphanumeric,
      '.',
      alphanumeric,
      alphanumeric,
      alphanumeric,
      '/',
      alphanumeric,
      alphanumeric,
      alphanumeric,
      alphanumeric,
      '-',
      numeric,
      numeric,
    ];
  };

  return (
    <S.Input mask={mask} pipe={(value) => value.toUpperCase()} guide={false} {...inputProps} />
  );
}

InputDocument.defaultProps = {
  inputMode: 'cnpj',
};

InputDocument.propTypes = {
  inputMode: PropTypes.oneOf(['cnpj', 'cpf']),
};

export default InputDocument;
